import React, { useEffect, useState } from "react";
import {
	Button,
	Modal,
	ModalBody,
	ModalContent,
	ModalFooter,
	ModalHeader,
	Textarea,
} from "@heroui/react";
import Markdown from "react-markdown";
import axios from "axios";
import remarkGfm from "remark-gfm";
import "github-markdown-css/github-markdown-light.css";
import rehypeRaw from "rehype-raw";
import DynamicCard from "./DynamicCard";
import BVPlayer from "./BVPlayer";
import remarkBreaks from "remark-breaks";

function NoticeDialog(props) {
	const [seconds, setSeconds] = useState(0);

	const [editableContent, setEditableContent] = useState(window.PRELOAD_AD);
	const [inEdit, setInEdit] = useState(false);

	useEffect(() => {
		var ref = setInterval(() => {
			if (seconds <= 0) {
				clearInterval(ref);
				return;
			}
			setSeconds((prev) => prev - 1);
		}, 1000);

		axios.get("/api/common/ad").then((res) => {
			setEditableContent(res.data);
		});

		return () => {
			clearInterval(ref);
		};
	}, []);

	return (
		<div data-nosnippet>
			<Modal
				onClose={seconds <= 0 && props.onClose}
				isOpen={true}
				size={isMobile() ? "2xl" : "2xl"}
				classNames={{
					base: "sm:max-h-[75vh] sm:h-[75vh]",
					body: "p-4",
				}}
				scrollBehavior={"inside"}
				backdrop={"blur"}
				isDismissable={seconds <= 0}
			>
				<ModalContent
					onClick={(e) => {
						if (inEdit && e.target.localName !== "textarea") {
							setInEdit(false);
						}
					}}
				>
					<ModalHeader>更新内容</ModalHeader>
					<ModalBody>
						<div className={"markdown-body list-disc"}>
							{inEdit ? (
								<Textarea
									className="max-w-[100vw]"
									label="支持Markdown语法"
									placeholder="Enter your description"
									value={editableContent}
									onChange={(e) =>
										setEditableContent(e.target.value)
									}
								></Textarea>
							) : (
								<div
									onClick={() => {
										setInEdit(true);
									}}
								>
									<Markdown
										remarkPlugins={[
											remarkGfm,
											remarkBreaks,
										]}
									>
										{editableContent}
									</Markdown>
								</div>
							)}
							<Markdown
								remarkPlugins={[remarkGfm, remarkBreaks]}
								rehypePlugins={[rehypeRaw]}
								components={{
									ul: ({ node, ...props }) => (
										<ul
											style={{
												listStyleType: "disc",
												paddingLeft: "2em",
												marginTop: "0",
											}}
											{...props}
										/>
									),
									"bili-dynamic-card": ({
										node,
										...props
									}) => {
										return (
											<DynamicCard
												item={{ OID: props.oid }}
												onClick={() => {
													window.open(
														"https://t.bilibili.com/" +
															props.oid,
													);
												}}
											></DynamicCard>
										);
									},
									"bv-player": ({ node, ...props }) => {
										return (
											<BVPlayer bv={props.bv}></BVPlayer>
										);
									},
								}}
							>
								{props.content}
							</Markdown>
						</div>
					</ModalBody>
					<ModalFooter>
						{inEdit && (
							<Button
								onClick={() => {
									setInEdit(false);
									setEditableContent((prev) => prev);
									axios.put("/api/common/ad", {
										content: editableContent,
									});
								}}
								color={"default"}
							>
								保存
							</Button>
						)}
						<Button
							onClick={() => {
								props.onClose && props.onClose();
							}}
							isDisabled={seconds > 0}
							color={seconds > 0 ? "default" : "primary"}
						>
							关闭 {seconds > 0 ? `${seconds} Seconds` : ""}
						</Button>
					</ModalFooter>
				</ModalContent>
			</Modal>
		</div>
	);
}

export default NoticeDialog;
